<template>
  <Head title="Login" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center text-3xl font-bold">{{ $t('message.login.welcome_back') }}</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <!-- <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" pattern=".+@nafafs\.com" title="Enter your nafa email e.g. firstname.lastname@nafafs.com" autocomplete="email" autofocus required autocapitalize="off" /> -->
          <email-input v-model="form.email" :error="form.errors.email" :label="$t('message.login.email')" pattern=".+@nafafs\.com" :title="$t('message.login.email_title')" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" :label="$t('message.login.show_password')" :type="passwordType" />
          <label class="flex items-center mt-6 select-none" for="showpassword">
            <input id="showpassword" v-model="showPassword" class="mr-1" type="checkbox" />
            <span class="text-sm">{{ $t('message.login.show_password') }}</span>
          </label>
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ $t('message.login.login') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import EmailInput from '@/Shared/EmailInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
    Logo,
    EmailInput,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
      showPassword: false,
      passwordType: 'password',
    }
  },
  watch: {
    showPassword(show) {
      this.passwordType = show ? 'text' : 'password'
    },
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
